import { render } from "./MenuAccordion.vue?vue&type=template&id=d6eda07a"
import script from "./MenuAccordion.vue?vue&type=script&lang=js"
export * from "./MenuAccordion.vue?vue&type=script&lang=js"
script.render = render

export default script